import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../redux/store";
import { useUscLabel } from "../../../../utils/labels";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import { financeServicesSelector } from "../../../../utils/financeUtils";
import { getServicesListSelector } from "../../../../utils/externalPriceUtils";
import UscCashPrice from "../price/UscCashPrice";
import BasketServices from "./content/BasketServices";
import UscBasketDetailsTotalPrice from "./content/UscBasketDetailsTotalPrice";
import BasketDisclaimers from "./content/BasketDisclaimers";
import BasketAdditionalCosts from "./content/BasketAdditionalCosts";
import * as Styles from "./UscBasketDetails.styles";
import BasketAccessories from "./content/BasketAccessories";
import DualCurrencyDisclaimer from "../../../../../shared-components/toyota/dual-currency-disclaimer/DualCurrencyDisclaimer";
import UscBasketFees from "./UscBasketFees";
import BasketInsurance from "./content/UscBasketInsurance";

const UscBasketDetails = ({ showPriceBreakdown }: { showPriceBreakdown: boolean }): JSX.Element => {
    const activeFinanceOption = useUscSelector((state) => state.basket.activeFinanceOption);
    const showFinanceTogglePrices = useUscSelector((state) => !state.uscSettings.hideFinanceTogglePrices);
    const { showTaxesAndCosts, showAdditionalCosts } = useUscSelector(
        (state) => state.uscSettings.basketConfig,
        shallowEqual,
    );

    const retailPriceLabel = useUscLabel("uscBasketConfigRetailPrice");

    const financeServices = useUscSelector(financeServicesSelector, shallowEqual);
    const services = useUscSelector(getServicesListSelector("included"), shallowEqual);

    // The retail price section is hidden on monthly when the finance toggle prices are hidden
    const showRetailPriceSection = activeFinanceOption === "cash" || showFinanceTogglePrices;

    const servicesLength = financeServices.length + services.length;

    return (
        <>
            <DualCurrencyDisclaimer />

            {showPriceBreakdown && (
                <Styles.PriceBreakdown>
                    {(!!servicesLength || showRetailPriceSection) && (
                        <>
                            {showRetailPriceSection && (
                                <Styles.RetailPriceList role="list">
                                    <li>
                                        <Text variant="h7">{retailPriceLabel}</Text>
                                        <Text variant="body-small-regular">
                                            <UscCashPrice showDiscountPrice showRetailPrice />
                                        </Text>
                                    </li>
                                </Styles.RetailPriceList>
                            )}
                            <BasketAccessories />
                            <BasketServices />
                        </>
                    )}

                    {showTaxesAndCosts && <UscBasketFees feeType="included" />}
                    {showFinanceTogglePrices && <UscBasketDetailsTotalPrice />}
                    {showAdditionalCosts && <BasketAdditionalCosts />}
                    <BasketInsurance />
                </Styles.PriceBreakdown>
            )}

            {/* We intentionally keep this separate from the price breakdown as these 
            disclaimers should always be shown, regardless of the price breakdown visibility */}
            <BasketDisclaimers />
        </>
    );
};

export default UscBasketDetails;
